export enum SHAPE_IDS {
  LARGE_SQUARE = "LargeSquare",
  SQUARE = "Square",
  QUARTER = "Quarter",
  PIXEL = "Pixel",
  BIT = "Bit",
  // Half Lap variants
  LARGE_HALF_LAP_VERTICAL = "LargeHalflapVertical",
  LARGE_HALF_LAP_HORIZONTAL = "LargeHalflapHorizontal",
  HALF_LAP_VERTICAL = "HalflapVertical",
  HALF_LAP_HORIZONTAL = "HalflapHorizontal",
  // Half Shiplap variants
  SHIPLAP_VERTICAL = "ShiplapVertical",
  SHIPLAP_HORIZONTAL = "ShiplapHorizontal",
  MINI_SHIPLAP_VERTICAL = "MiniShiplapVertical",
  MINI_SHIPLAP_HORIZONTAL = "MiniShiplapHorizontal",
  // Triangle variants
  LEFT_BOTTOM_TRIANGLE = "LeftBottomTriangle",
  RIGHT_TOP_TRIANGLE = "RightTopTriangle",
  LEFT_TOP_TRIANGLE = "LeftTopTriangle",
  RIGHT_BOTTOM_TRIANGLE = "RightBottomTriangle",
  // Small Triangle variants (equilateral)
  SMALL_TRIANGLE_TOP = "SmallTriangleTop",
  SMALL_TRIANGLE_BOTTOM = "SmallTriangleBottom",
  // Small 90 Triangle variants
  SMALL_90_LEFT_BOTTOM_TRIANGLE = "Small90LeftBottomTriangle",
  SMALL_90_RIGHT_TOP_TRIANGLE = "Small90RightTopTriangle",
  SMALL_90_LEFT_TOP_TRIANGLE = "Small90LeftTopTriangle",
  SMALL_90_RIGHT_BOTTOM_TRIANGLE = "Small90RightBottomTriangle",
  // Large Half Circle variants
  LARGE_HALF_CIRCLE_VERTICAL = "LargeHalfCircleVertical",
  LARGE_HALF_CIRCLE_HORIZONTAL = "LargeHalfCircleHorizontal",
  LARGE_HALF_CIRCLE_VERTICAL_FLIPPED = "LargeHalfCircleVerticalFlipped",
  LARGE_HALF_CIRCLE_HORIZONTAL_FLIPPED = "LargeHalfCircleHorizontalFlipped",
  // Quarter Circle variants
  QUARTER_CIRCLE_BOTTOM_LEFT = "QuarterCircleBottomLeft",
  QUARTER_CIRCLE_BOTTOM_RIGHT = "QuarterCircleBottomRight",
  QUARTER_CIRCLE_TOP_LEFT = "QuarterCircleTopLeft",
  QUARTER_CIRCLE_TOP_RIGHT = "QuarterCircleTopRight",
  // Half Circle variants
  HALF_CIRCLE_VERTICAL = "HalfCircleVertical",
  HALF_CIRCLE_HORIZONTAL = "HalfCircleHorizontal",
  HALF_CIRCLE_VERTICAL_FLIPPED = "HalfCircleVerticalFlipped",
  HALF_CIRCLE_HORIZONTAL_FLIPPED = "HalfCircleHorizontalFlipped",
  // Small Half Circle variants
  SMALL_HALF_CIRCLE_VERTICAL = "SmallHalfCircleVertical",
  SMALL_HALF_CIRCLE_HORIZONTAL = "SmallHalfCircleHorizontal",
  SMALL_HALF_CIRCLE_VERTICAL_FLIPPED = "SmallHalfCircleVerticalFlipped",
  SMALL_HALF_CIRCLE_HORIZONTAL_FLIPPED = "SmallHalfCircleHorizontalFlipped",
  // Engraved variants
  ENGRAVED_BACK_SLASH = "EngravedBackSlash",
  ENGRAVED_FORWARD_SLASH = "EngravedForwardSlash",
  ENGRAVED_CROSS = "EngravedCross",
  ENGRAVED_FOUR_SQUARE = "EngravedFourSquare",
  ENGRAVED_PARALLEL = "EngravedParallel",
  ENGRAVED_PARALLEL_VERTICAL = "EngravedParallelVertical",
  ENGRAVED_TANGENT = "EngravedTangent",
  ENGRAVED_TANGENT_90 = "EngravedTangent90",
  ENGRAVED_TANGENT_180 = "EngravedTangent180",
  ENGRAVED_TANGENT_270 = "EngravedTangent270",
  ENGRAVED_CRISS_CROSS = "EngravedCrissCross",
  ENGRAVED_CRISS_CROSS_90 = "EngravedCrissCross90",
  ENGRAVED_CRISS_CROSS_180 = "EngravedCrissCross180",
  ENGRAVED_CRISS_CROSS_270 = "EngravedCrissCross270",
  ENGRAVED_KNOT = "EngravedKnot",
  ENGRAVED_KNOT_90 = "EngravedKnot90",
  ENGRAVED_KNOT_180 = "EngravedKnot180",
  ENGRAVED_KNOT_270 = "EngravedKnot270",
  ENGRAVED_CONVERGE = "EngravedConverge",
  ENGRAVED_CONVERGE_90 = "EngravedConverge90",
  ENGRAVED_CONVERGE_180 = "EngravedConverge180",
  ENGRAVED_CONVERGE_270 = "EngravedConverge270",
  ENGRAVED_OFFSET = "EngravedOffset",
  ENGRAVED_OFFSET_90 = "EngravedOffset90",
  ENGRAVED_OFFSET_180 = "EngravedOffset180",
  ENGRAVED_OFFSET_270 = "EngravedOffset270",
  ENGRAVED_TOPO = "EngravedTopo",
  ENGRAVED_TOPO_90 = "EngravedTopo90",
  ENGRAVED_TOPO_180 = "EngravedTopo180",
  ENGRAVED_TOPO_270 = "EngravedTopo270",
  ENGRAVED_ARC = "EngravedArc",
  ENGRAVED_ARC_90 = "EngravedArc90",
  ENGRAVED_LARGE_PARALLEL = "EngravedLargeParallel",
  ENGRAVED_LARGE_PARALLEL_90 = "EngravedLargeParallel90",
  ENGRAVED_RIVER = "EngravedRiver",
  ENGRAVED_RIVER_90 = "EngravedRiver90",
  ENGRAVED_SUBWAY = "EngravedSubway",
  ENGRAVED_SUBWAY_90 = "EngravedSubway90",
  ENGRAVED_SUBWAY_180 = "EngravedSubway180",
  ENGRAVED_SUBWAY_270 = "EngravedSubway270",
  ENGRAVED_ZEN = "EngravedZen",
  ENGRAVED_ZEN_90 = "EngravedZen90",
  ENGRAVED_ZEN_180 = "EngravedZen180",
  ENGRAVED_ZEN_270 = "EngravedZen270",
  // Peak Tile variants
  PEAK_SMALL = "SmallPeak",
  PEAK_LARGE = "LargeCenterPeak",
  PEAK_LARGE_OFFSET = "LargeUpperPeak",
}
